import { useMutation } from "@tanstack/react-query"
import { Button } from "components"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import NewModalWrapper from "components/new-stuff/ui/modals/NewModalWrapper"
import { useState } from "react"
import { paymentSchedulesService } from "services/paymentSchedulesService"
import { useAppNotificationStore } from "stores"
import getIdFromKey from "utils/getIdFromKey"
import { onQueryError } from "utils/utils"
type Props = {
  onClose: () => void
  invalidateQueries: () => void
  open: boolean
  paymentId: string
  x: string
  currency?: string
}

export const UpdatePayment = ({
  onClose,
  open,
  paymentId,
  x,
  currency,
  invalidateQueries,
}: Props) => {
  const { toast } = useAppNotificationStore()

  const { isLoading: isSubmittingUpdate, mutate: submitUpdateSingle } =
    useMutation({
      mutationFn: async () => {
        const data = await paymentSchedulesService.updateItemDetail(
          paymentId,
          currency
        )

        return data
      },
      onSuccess: (data) => {
        onClose()
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-update-success")
        invalidateQueries()
      },
      onError: (e) => {
        onClose()
        onQueryError(e)
      },
    })

  const { isLoading: isSubmittingUpdateAll, mutate: submitUpdateAll } =
    useMutation({
      mutationFn: async () => {
        const data = await paymentSchedulesService.updateItemDetails(
          paymentId,
          currency
        )

        return data
      },
      onSuccess: (data) => {
        onClose()
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-update-success")
        invalidateQueries()
      },
      onError: (e) => {
        onClose()
        onQueryError(e)
      },
    })

  return (
    <NewModalWrapper
      open={open}
      title="Update Account Details"
      className="w-[750px]"
      onClose={onClose}
    >
      <div className="px-5 py-3 flex flex-col items-center">
        <p className="text-[#15294B] text-sm mb-6">
          {paymentId == getIdFromKey(x || "")
            ? `All beneficiaries account details will be updated - if they have changed.
          Are you sure you want to continue?`
            : `Beneficiary account details will be updated - if they have changed.
          Are you sure you want to continue?`}
        </p>
      </div>
      <div className="border py-5 px-6 flex gap-4 justify-end ">
        <Button
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          submitting={isSubmittingUpdate || isSubmittingUpdateAll}
          onClick={() => {
            mixPanelEvent("pay-schedule-payout-update-init")
            {
              paymentId == getIdFromKey(x || "")
                ? submitUpdateAll()
                : submitUpdateSingle()
            }
          }}
        >
          Update
        </Button>
      </div>
    </NewModalWrapper>
  )
}

export default UpdatePayment
